/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { MutationCache, QueryClient } from '@tanstack/react-query';

import i18n from '@/i18n/i18n';
import { toast } from '@/stores/toastStore';

/** Query defaults with conservative retries; unhandled mutation errors show a toast. */
export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: () => toast.error(i18n.t('toast.error')),
  }),
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
